// extracted by mini-css-extract-plugin
module.exports = {"button":"LightweightCardAction_button__NtIp1","detailsButton":"LightweightCardAction_detailsButton__TwOPQ","actions":"LightweightCardAction_actions__iY1B_"};